import { useCallback } from 'react';
import shallow from 'zustand/shallow';
import { useSearchParams } from 'react-router-dom';
import { houseApi } from '@api';
import { useHouseState } from '@root/state';
import { IHouse } from '@root/types/house';
import { ILoading } from '@root/types/common';

const useHouseList = (): {
  currentHouseId: string;
  loading: ILoading;
  houses: IHouse[];
  updateTime: number;
  getHouseList: () => void;
  setCurrentHouseId: (v: string) => void;
} => {
  const {
    loading,
    updateTime,
    currentHouseId,
    houses,
    setLoading,
    setHouses,
    setCurrentHouseId,
  } = useHouseState(
    (state) => ({
      loading: state.loading,
      currentHouseId: state.currentHouseId,
      houses: state.houses,
      updateTime: state.updateTime,
      setLoading: state.setLoading,
      setHouses: state.setHouses,
      setCurrentHouseId: state.setCurrentHouseId,
    }),
    shallow,
  );

  const [searchParams, setSearchParams] = useSearchParams();

  const queryHouseId = searchParams.get('houseId');

  const getHouseList = useCallback(() => {
    setLoading(0);
    houseApi
      .getHouseList()
      .then((data: any) => {
        // 过滤分享的家
        const _data = data?.length ? data.filter((i: IHouse) => i.isOwner) : [];

        setHouses(_data);
        setLoading(1);

        if (!_data.length) {
          return;
        }

        if (
          queryHouseId &&
          _data.findIndex((i: IHouse) => i.id === queryHouseId) !== -1
        ) {
          // Url 上的优先
          setCurrentHouseId(queryHouseId);
          setSearchParams('', { replace: true });
          return;
        }

        // 本地无数据 或数据不在当前家列表中 获取默认的家
        if (
          !currentHouseId ||
          _data.findIndex((i: IHouse) => i.id === currentHouseId) === -1
        ) {
          // 默认家 ID
          const { id } = _data.find((i: IHouse) => i.isDefault) || _data[0];
          setCurrentHouseId(id);
        }

        if (queryHouseId) {
          // 清楚 url 数据
          setSearchParams('', { replace: true });
        }
      })
      .catch(() => {
        setLoading(2);
      });
  }, [
    currentHouseId,
    queryHouseId,
    setCurrentHouseId,
    setHouses,
    setLoading,
    setSearchParams,
  ]);

  // useEffect(() => {
  //   // 10m 无需要重复取数据
  //   if (updateTime && new Date().getTime() - updateTime < 10 * 60 * 1000) {
  //     return;
  //   }
  //   getHouseList();
  // }, [getHouseList, updateTime]);

  return {
    loading,
    currentHouseId: loading > 0 ? currentHouseId : '',
    houses,
    updateTime,
    getHouseList,
    setCurrentHouseId,
  };
};

const useCurrentHouseId = (): string => {
  const currentHouseId = useHouseState((state) => state.currentHouseId);
  return currentHouseId;
};

export { useCurrentHouseId };

export default useHouseList;
